// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2957":"47e7e801f9f0a451a5ac","5338":"bd8ca1c6a3fe064e1da4"}[chunkId] + ".js";
};